module.exports = __webpack_public_path__ + "img/team1.ac3ee933.png";